export const SORT = {
  PREMIUM: "PREMIUM",
  INCOME: "INCOME",
  DEATH_BENEFIT: "DEATH_BENEFIT",
  CASH_VALUE: "CASH_VALUE",
  APPROVAL_TIME: "APPROVAL_TIME",
  NO_EXAM: "NO_EXAM",
  PREFERRED: "PREFERRED",
};

export type QuoteSort = (typeof SORT)[keyof typeof SORT];
